var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8285 8.67829C17.2037 9.16912 17.2037 9.83175 16.8285 10.3218C15.6465 11.8647 12.8108 15.0417 9.50003 15.0417C6.18928 15.0417 3.35353 11.8647 2.17157 10.3218C1.989 10.0868 1.88989 9.79764 1.88989 9.50004C1.88989 9.20244 1.989 8.91331 2.17157 8.67829C3.35353 7.13533 6.18928 3.95837 9.50003 3.95837C12.8108 3.95837 15.6465 7.13533 16.8285 8.67829V8.67829Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.875C10.8117 11.875 11.875 10.8117 11.875 9.5C11.875 8.18832 10.8117 7.125 9.5 7.125C8.18832 7.125 7.125 8.18832 7.125 9.5C7.125 10.8117 8.18832 11.875 9.5 11.875Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewEye);
export default __webpack_public_path__ + "static/media/previewEye.b44dcef575b54608f8154787083c0eb4.svg";
export { ForwardRef as ReactComponent };